/**
 * services/tvMode.ts · TV Mode 大屏 v340 (P2 车间大屏)
 *
 * F11 全屏 + body[data-tv-mode] · 隐 NAV/sidebar · 字号放大
 *   - URL ?tv=1 自动启动
 *   - localStorage tn_tv_mode 持久
 *   - Esc / 双击退出
 */

const CSS_ID = 'tn-tv-mode-style';

function injectTvCss(): void {
  if (document.getElementById(CSS_ID)) return;
  const s = document.createElement('style');
  s.id = CSS_ID;
  s.textContent = `
    body[data-tv-mode] { background: #0a0e1a !important; }
    body[data-tv-mode] aside,
    body[data-tv-mode] nav.top-nav-bar,
    body[data-tv-mode] header,
    body[data-tv-mode] #tn-syncCenter-btn,
    body[data-tv-mode] [data-tv-hide] { display: none !important; }
    body[data-tv-mode] main { padding: 16px !important; background: transparent !important; }
    body[data-tv-mode] h1, body[data-tv-mode] h2 { color: #e0f2fe !important; }
    body[data-tv-mode] .bg-white { background: #1e293b !important; color: #e2e8f0 !important; border-color: #334155 !important; }
    body[data-tv-mode] .tn-data-table { background: #1e293b !important; }
    body[data-tv-mode] table { color: #e2e8f0 !important; }
    body[data-tv-mode] table thead { background: #0f172a !important; }
    body[data-tv-mode] table tbody tr { border-bottom: 1px solid #334155 !important; }
    body[data-tv-mode] table tbody tr:hover { background: rgba(59,130,246,0.1) !important; }
    body[data-tv-mode] { font-size: clamp(14px, 1.3vw, 22px); }
    body[data-tv-mode] h1 { font-size: clamp(28px, 2.5vw, 48px) !important; }
    body[data-tv-mode] h2 { font-size: clamp(18px, 1.8vw, 32px) !important; }
    body[data-tv-mode] .tn-kpi-value, body[data-tv-mode] [class*="text-3xl"] { font-size: clamp(32px, 3vw, 60px) !important; }
    #tn-tv-exit { position:fixed; top:12px; right:12px; z-index:99999; padding:8px 14px; background:rgba(255,255,255,0.9); color:#1e293b; border:none; border-radius:6px; cursor:pointer; font-size:13px; font-weight:600; }
    body:not([data-tv-mode]) #tn-tv-exit { display: none; }
  `;
  document.head.appendChild(s);
}

export function enterTvMode(): void {
  injectTvCss();
  document.body.dataset.tvMode = '1';
  try { localStorage.setItem('tn_tv_mode', '1'); } catch {}
  // 添加退出按钮
  if (!document.getElementById('tn-tv-exit')) {
    const btn = document.createElement('button');
    btn.id = 'tn-tv-exit';
    btn.textContent = '✕ 退出 TV (Esc / 双击)';
    btn.onclick = exitTvMode;
    document.body.appendChild(btn);
  }
  // v351 · Andon ticker 自动挂底部 + 60s 自动刷新
  void import('@widgets/AndonTicker').then(({ mountAndonTicker, refreshAndonTicker }) => {
    mountAndonTicker();
    void import('@services/autoRefresh').then(({ registerAutoRefresh }) => {
      registerAutoRefresh('tv-andon', refreshAndonTicker, 30_000);
    });
  });
  // 真全屏
  if (document.documentElement.requestFullscreen) {
    document.documentElement.requestFullscreen().catch(() => { /* 用户未允许 · 仍 TV mode 但非 fullscreen */ });
  }
}

export function exitTvMode(): void {
  delete document.body.dataset.tvMode;
  try { localStorage.removeItem('tn_tv_mode'); } catch {}
  document.getElementById('tn-tv-exit')?.remove();
  // v351 · 清掉 Andon + auto refresh
  void import('@widgets/AndonTicker').then(({ unmountAndonTicker }) => unmountAndonTicker());
  void import('@services/autoRefresh').then(({ unregisterAutoRefresh }) => unregisterAutoRefresh('tv-andon'));
  if (document.fullscreenElement) document.exitFullscreen().catch(() => {});
}

export function toggleTvMode(): void {
  if (document.body.dataset.tvMode) exitTvMode();
  else enterTvMode();
}

export function initTvMode(): void {
  // URL ?tv=1 自动启
  if (new URLSearchParams(location.search).get('tv') === '1') setTimeout(enterTvMode, 200);
  // localStorage 恢复
  else { try { if (localStorage.getItem('tn_tv_mode') === '1') setTimeout(enterTvMode, 200); } catch {} }
  // Esc / F11 / 双击退出
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.dataset.tvMode) exitTvMode();
    if (e.key === 'F11' && !e.shiftKey) { e.preventDefault(); toggleTvMode(); }
  });
  document.addEventListener('dblclick', (e) => {
    if (document.body.dataset.tvMode && (e.target as HTMLElement)?.tagName !== 'BUTTON') exitTvMode();
  });
}

initTvMode();
